import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { BASE_URL, MODALACTION, RESPONSE } from '../../config/constants';
import ReactNotification, {store} from 'react-notifications-component';
import Services from '../../services/service';
import moment from 'moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';

const { VIEW } = MODALACTION;
const { FAILED } = RESPONSE;

const tableOptionsDetail = {
  filterType: 'dropdown',
  selectableRows: 'none',
  search: false,
  filter: false,
  download: false,
  print: false,
  viewColumns: false,
  pagination: false,
  setTableProps: () => {
    return {
      size: "small"
    };
  }
};

const labelStyle = {
  textAlign: "left", 
  padding: "8px", 
  border: "1px solid #000000", 
  width: "70%", 
  overflow: "hidden"
};
const tableStyle = {
  width: "100%", 
  borderCollapse: "collapse", 
  tableLayout: "fixed"
};
const valueStyle = {
  textAlign: "left", 
  padding: "8px", 
  border: "1px solid #000000", 
  overflow: "hidden"
};
const checkboxStyle = {
  textAlign: "center", 
  padding: "8px", 
  border: "1px solid #000000", 
  overflow: "hidden"
};

class VisitorList extends Component {
    
  constructor(props){
    super(props);
    this.state = {
      modalAdd: false,
      dataVisitor: [],
      componentData: [],
      disclaimerData: [],
      officerList: [],
      detailVisitor: [],
      timeIn: [],
      timeOut: []
    };
    this.initialState = this.state;
  };

  componentDidMount(){
    this.getDataVisitor();
  };

  getDataVisitor = () => {
    Services.getVisitorList()
      .then(res => {
        this.setState({dataVisitor: res});
      })
      .catch(err => console.log(err))
  };

  onCLickVisitorDetail = (method, data) => {
    this.toggleAddModal(method, data);
    const param = data._id;
    Services.getVisitorDetail(param)
      .then(res => {
        this.setState({
          detailVisitor: res,
          componentData: res.componentData,
          disclaimerData: res.disclaimerData,
          timeIn: res.fileIn ? res.fileIn : '' ,
          timeOut: res.fileOut ? res.fileOut : '',
          officerList: res.officesList
        })
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      });
  };

  toggleAddModal = (action = '', item = {}) => {
    this.setState({
      modalAdd: !this.state.modalAdd,
      actionModal: action,
      selectedItem: item
    });
  };

  renderVisitorDetail = () => {
    const { detailVisitor } = this.state;
    let visitorDetail = [];
    visitorDetail.push(detailVisitor);
    const columns = [
      {
        name: "createDate",
        label: "Tanggal Pengajuan",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment.utc(value).format('DD-MM-YYYY HH:mm')
        }
      },
      {
        name: "visitorType",
        label: "Tipe",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "timeIn",
        label: "Masuk",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment.utc(value).format('DD-MM-YYYY HH:mm')
        }
      },
      {
        name: "timeOut",
        label: "Keluar",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment.utc(value).format('DD-MM-YYYY HH:mm')
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          data={visitorDetail}
          columns={columns}
          options={tableOptionsDetail}
        />
      </MuiThemeProvider>
    )
  }; 

  renderComponentData = () => {
    return this.state.componentData.map((item) => {
      return (
        <table style={tableStyle}>
          <tr>
            <td style={labelStyle}>{item.label}</td>
            <td style={valueStyle}>{item.value}</td>
          </tr>
        </table>
      )
    }, this);
  };

  renderDisclaimerData = () => {
    return this.state.disclaimerData.map((item) => {
        return (
          <table style={tableStyle}>
            <tr>
              <td style={labelStyle}>{item.disclaimer}</td>
              <td style={checkboxStyle}>
                <input type="checkbox" checked={item.checked} />
              </td>
            </tr>
          </table>
        )
      }, this);
  };

  renderImageIn = () => {
    const { timeIn } = this.state;
    return timeIn.map((item, idx) => {
      if(idx % 2 === 0){
        return (
          <div className="row m-b-5" key={idx}>
            <div className="col-lg-6">
              <img 
                class="img-responsive" 
                src={`${BASE_URL}/file-visitor/${item}`} 
                alt="Visitor In"
              />
            </div>
            {(timeIn[idx+1]) &&
              (
                <div className="col-lg-6">
                  <img 
                    class="img-responsive" 
                    src={`${BASE_URL}/file-visitor/${timeIn[idx+1]}`} 
                    alt="Visitor In"
                  />
                </div>
              )
            }
          </div>
        )
      }
      return(<></>);
    });
  };

  renderImageOut = () => {
    const { timeOut } = this.state;
    return timeOut.map((item, idx )=> {
      if(idx % 2 === 0){
        return (
          <div className="row m-b-5" key={idx}>
            <div className="col-lg-6">
              <img 
                class="img-responsive" 
                src={`${BASE_URL}/file-visitor/${item}`} 
                alt="Visitor Out"
              />
            </div>
            {(timeOut[idx+1]) &&
              (
                <div className="col-lg-6">
                  <img 
                    class="img-responsive" 
                    src={`${BASE_URL}/file-visitor/${timeOut[idx+1]}`} 
                    alt="Visitor Out"
                  />
                </div>
              )
            }
          </div>
        )
      }
      return(<></>);
    });
  };

  renderOfficerList = () => {
    const { officerList } = this.state;
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "position",
        label: "Posisi",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "name",
        label: "Petugas",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
    ];

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          data={officerList}
          columns={columns}
          options={tableOptionsDetail}
        />
      </MuiThemeProvider>
    )
  };

  renderDetailVisitorModal = () => {
    return (
      <Modal size="lg" style={{ width: '100%'}} isOpen={this.state.modalAdd} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>Visitor Detail</ModalHeader>
        <ModalBody>
          <ModalHeader>Detail Pengunjung</ModalHeader>
            {this.renderVisitorDetail()}
            <div style={{marginTop: "30px"}}></div>
            {this.renderComponentData()}
          <ModalHeader>Disclaimer</ModalHeader>
            {this.renderDisclaimerData()}
          <ModalHeader>Foto Masuk</ModalHeader>
            <div style={{marginTop: "20px"}}></div>
            {this.renderImageIn()}
          <ModalHeader>Foto Keluar</ModalHeader>
            <div style={{marginTop: "20px"}}></div>
            {this.renderImageOut()}
          <ModalHeader>Petugas Pemeriksa</ModalHeader>
            {this.renderOfficerList()}
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Back</button>
        </ModalFooter>
      </Modal>
    )
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Pengunjung</li>
      </ol>
      <h1 className="page-header">Laporan Pengunjung</h1>
    </div>
  );

  addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
    store.addNotification({
      title: notificationTitle,
      message: notificationMessage,
      type: notificationType,
      insert: "top",
      container: notificationPosition,
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true }
    });
  };

  toggleNotification = action => {
    if (action === FAILED) {
      this.addNotification('danger', 'Danger', 'Oops something went wrong !', 'top-right');
    }
  };

  renderTableVisitor = () => {
    const { dataVisitor } = this.state;
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "createDate",
        label: "Tanggal Pengajuan",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment.utc(value).format('DD-MM-YYYY HH:mm')
        }
      },
      {
        name: "fullname",
        label: "Nama Visitor",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "visitorType",
        label: "Tipe",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "timeIn",
        label: "Masuk",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment.utc(value).format('DD-MM-YYYY HH:mm')
        }
      },
      {
        name: "timeOut",
        label: "Keluar",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment.utc(value).format('DD-MM-YYYY HH:mm')
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px" }}),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="with-btn text-nowrap">
                <button
                  className="btn btn-sm btn-primary width-60 m-r-2"
                  onClick={() => this.onCLickVisitorDetail(VIEW, dataVisitor[tableMeta.rowIndex])}
                >{VIEW}</button>
              </div>
            );
          }
        }
      }
    ];

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Pengunjung"}
          data={dataVisitor}
          columns={columns}
          options={tableOptions}
        />
      </MuiThemeProvider>
    )
  };

  render() {
    return (
      <div>
        <ReactNotification/>
        {this.renderBreadcrumb()}
        <div>
          {this.renderTableVisitor()}
        </div>
        {this.renderDetailVisitorModal()}
      </div>
    )
  }
}

export default VisitorList